import React, { useState } from 'react';

import { sanitize } from 'lib/helpers/sanitize';
import { cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import { formatLabel } from 'components/shared/ExpandableToolbar/lib/helpers';

import { formatChangedValues } from '../lib/formatChangedValues';

const MAX_VISIBLE_ITEMS = 2;

const ActivityContent = ({
  isChild = false,
  formattedChanges = [],
  action,
  overwriteActivities = {}
}) => {
  const isDelete = action === 'delete';
  const isUpload = action === 'upload';
  const isAttachment = isDelete || isUpload;

  const [showAll, setShowAll] = useState(false);

  const hasMoreItems = formattedChanges.length > MAX_VISIBLE_ITEMS;
  const visibleChanges =
    showAll || !hasMoreItems ? formattedChanges : formattedChanges.slice(0, MAX_VISIBLE_ITEMS);

  return (
    <ul
      className={cn(
        'flex flex-1 flex-col gap-1',
        !isChild && 'ml-2',
        'border-b-0 border-l-[1px] border-r-0 border-t-0 border-solid border-neutral-300 pl-2'
      )}>
      {visibleChanges.map((item) => {
        const { key, isNestedKey, prevValueRaw, currValueRaw, prevValue, currValue } = item;

        const className = 'flex flex-wrap items-center gap-1 text-xs leading-5';

        if (Object.keys(overwriteActivities).includes(key)) {
          return (
            <p key={key} className="flex flex-wrap gap-1 text-xs leading-5 text-neutral-700">
              {overwriteActivities[key]}
            </p>
          );
        }

        return (
          <li key={key} className={className}>
            <span className="font-semibold">{formatLabel(key)}</span>

            {isNestedKey ? (
              <ActivityContent
                key={key}
                isChild
                action={action}
                formattedChanges={
                  formatChangedValues({
                    activities: [{ previousValues: prevValueRaw, currentValues: currValueRaw }]
                  })[0]?.formattedChanges || []
                }
              />
            ) : (
              <div className={className}>
                <div className="flex items-center gap-1">
                  {!isAttachment && <span>from</span>}

                  {(!isAttachment || isDelete) && (
                    <span dangerouslySetInnerHTML={sanitize(prevValue)} />
                  )}
                </div>

                {(!isAttachment || isUpload) && (
                  <div className="flex items-center gap-1">
                    {!isAttachment && <span>to</span>}

                    <span
                      className={cn('inline-flex font-semibold text-neutral-800')}
                      dangerouslySetInnerHTML={sanitize(currValue)}
                    />
                  </div>
                )}
              </div>
            )}
          </li>
        );
      })}

      {hasMoreItems && (
        <Button
          size="xs"
          variant="link"
          text={`Show ${showAll ? 'less' : 'all...'}`}
          onClick={() => setShowAll((prev) => !prev)}
          className="pt-1"
        />
      )}
    </ul>
  );
};

export default ActivityContent;
